// Prefix every localStorage key with a version so that we can invalidate old keys if we need to.
const KEY_PREFIX = "v5";
export function getItem(key, defaultValue, storage = window.localStorage) {
    if (defaultValue instanceof Storage) {
        storage = defaultValue;
        defaultValue = undefined;
    }
    try {
        const value = storage.getItem(key);
        if (value === null) {
            return defaultValue;
        }
        return JSON.parse(value);
    }
    catch (e) {
        // Either local storage is not supported. Either way, return the default value.
    }
    return defaultValue;
}
export function setItem(key, value, storage = window.localStorage) {
    try {
        storage.setItem(key, JSON.stringify(value));
    }
    catch (e) {
        // No way to recover
    }
}
export function makeKey(key) {
    return [KEY_PREFIX, window.SPEEDCURVE_CONFIG.accountId, key].join(":");
}
